export default __webpack_public_path__ + "static/media/whatsapp.420bc3f7.svg";